export const LANDING_PAGE_TYPE = 'landing_cian_new';
export const LANDING_EVENT_CATEGORY = 'landing_cian_new';
export const OLD_EVENT_NAME = 'oldevent';

export const BUTTON_TEXT = {
  SUBMIT_AD: 'Подать объявление',
  PLACE_AD: 'Разместить объявление',
  LOGIN: 'Войти на Циан',
  PLACE: 'Разместить',
} as const;

export type TButtonText = (typeof BUTTON_TEXT)[keyof typeof BUTTON_TEXT];
